import { useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/homeworks/HomeworksAction";
import {
  copy,
  ExportButton,
  exportToExcel,
  exportToPDF,
  getAuthorities,
  print
} from "../../../../../../_helpers/Helpers";
import { 
  Card, 
  CardBody, 
  CardHeader,
  CardHeaderToolbar
} from "../../../../../../_metronic/_partials/controls";
import { useStudentsUIContext } from "./StudentsUIContext";
import { StudentsFilter } from "./students-filter/StudentsFilter";
import { StudentsTable } from "./students-table/StudentsTable";

export function StudentsCard() {
  // Students UI Context
  const studentsUIContext = useStudentsUIContext();
  const studentsUIProps = useMemo(() => {
    return {
      definition: studentsUIContext.definition,
      queryParams: studentsUIContext.queryParams
    };
  }, [studentsUIContext]);

  // Getting curret state of Students from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.homeworks }),
    shallowEqual
  );  
  const { authorities } = currentState;

  // Authority Parameters
  const { isExportationAuthorized } = getAuthorities(authorities);

  // Students Redux state
  const dispatch = useDispatch();

  /** Belli Bir Ödev Gönderilen Belli Bir Öğrenci Listesini Excele Aktarır */
  const exportStudentsToExcel = () => {
    dispatch(actions.getAllHomeworkReceipents(studentsUIProps.queryParams)).then(entities => {
      if (entities.isSuccess === false) return;
      const rows = [];
      const widths = [25, 30, 20, 40];
      const columns = ["Öğrenci Numarası", "Adı Soyadı", "Durum", "Değerlendirme Açıklaması"];
      entities.forEach(entity => rows.push([
        entity.studentNumber,
        entity.studentName,
        entity.homeworkStatusName,
        entity.evaluationExplanation
      ]));
      const filename = studentsUIProps.definition + " Öğrenci Listesi";
      const sheetname = "Öğrenci Listesi"
      exportToExcel({ columns, rows, widths, filename, sheetname });
    });
  }

  /** Belli Bir Ödev Gönderilen Belli Bir Öğrenci Listesini PDF e Aktarır */
  const exportStudentsToPDF = () => {
    dispatch(actions.getAllHomeworkReceipents(studentsUIProps.queryParams)).then(entities => {
    if (entities.isSuccess === false) return;
      const views = [ 
        {
          header: "Öğrenci Numarası",
          rows: entities.map(entity => entity.studentNumber)
        },
        {
          header: "Adı Soyadı",
          rows: entities.map(entity => entity.studentName)
        },
        {
          header: "Durum",
          rows: entities.map(entity => entity.homeworkStatusName)
        },
        {
          header: "Değerlendirme Açıklaması",
          rows: entities.map(entity => entity.evaluationExplanation)
        }
      ];
        
      const filename = studentsUIProps.definition + " Öğrenci Listesi";
      exportToPDF(views, filename);
    });
  }

  /** Belli Bir Ödev Gönderilen Belli Bir Öğrenci Listesini Yazdırma Penceresini Açar */
  const printStudents = () => {
    dispatch(actions.getAllHomeworkReceipents(studentsUIProps.queryParams)).then(entities => {
      if (entities.isSuccess === false) return;
      const data = [];
      const header = studentsUIProps.definition + " Öğrenci Listesi";
      const properties = ["Öğrenci Numarası", "Adı Soyadı", "Durum", "Değerlendirme Açıklaması"];

      entities.forEach(entity => {
        data.push({      
          "Öğrenci Numarası": entity.studentNumber,
          "Adı Soyadı": entity.studentName,
          "Durum": entity.homeworkStatusName,
          "Değerlendirme Açıklaması": entity.evaluationExplanation ?? ""
        });
      });

      print({ data, properties, header });
    });
  }

  /** Belli Bir Ödev Gönderilen Belli Bir Öğrenci Listesini Panoya Kopyalar */
  const copyStudents = () => {
    dispatch(actions.getAllHomeworkReceipents(studentsUIProps.queryParams)).then(entities => {
      if (entities.isSuccess === false) return;
      const rows = [];
      const columns = ["Öğrenci Numarası", "Adı Soyadı", "Durum", "Değerlendirme Açıklaması"];
      const header = studentsUIProps.definition + " Öğrenci Listesi";
      entities.forEach(entity => rows.push([
        entity.studentNumber,
        entity.studentName,
        entity.homeworkStatusName,
        entity.evaluationExplanation ?? ""
      ]));
      copy({ header, columns, rows });
    });
  }

  return (
    <Card>
      <CardHeader title="Öğrenci Listesi">
        {
          isExportationAuthorized &&
          <CardHeaderToolbar>
            <ExportButton
              exportToExcel={exportStudentsToExcel}
              exportToPDF={exportStudentsToPDF}
              print={printStudents}
              copy={copyStudents}
            />
          </CardHeaderToolbar>
        }
      </CardHeader>
      <CardBody>
        <StudentsFilter />
        <StudentsTable />
      </CardBody>
    </Card>
  );
}